export const selectorDataActual = state => state.dataActual;
export const selectorPeticioDataActualEnCurs = state => state.peticioDataActualEnCurs;



// WEBPACK FOOTER //
// ./src/selectors/selector_data_actual.js